import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { TermsAndConditionsData } from '../../whiteLabel/mediaCorps/services/misc/misc-data';
import { MiscAdapter } from '../../whiteLabel/mediaCorps/adapters/misc-adapter';

@Injectable({
    providedIn: 'root'
})
export class TermsAndConditionsService {

    public accepted: boolean;
    public termsData: TermsAndConditionsData = null;

    constructor(private miscAdapter: MiscAdapter) { }

    public hasAcceptedTerms(): Promise<boolean> {
        if (this.accepted || this.termsData) {
            return Promise.resolve(this.accepted);
        }
        return this.getUnacceptedTermsAndConditionsData().then(terms => {
            this.termsData = terms;
            if (!this.termsData.data || this.termsData.data.length === 0) {
                this.accepted = true;
            }
            return this.accepted;
        });
    }

    public getUnacceptedTermsAndConditionsData(): Promise<TermsAndConditionsData> {
        return this.termsData ?
            Promise.resolve(this.termsData) :
            this.miscAdapter.getTermsAndConditionsData(false).then(termsData => termsData);
    }
    
    public getTermsAndConditionsFile(download_url: string): Promise<ArrayBuffer> {
        return this.miscAdapter.getTermsAndConditionsFile(download_url);
    }

    public acceptTermsAndConditions(termsVersionId) {
        return this.miscAdapter.acceptTermsAndConditions(termsVersionId);
    }

}
